//declare let moment;
import * as moment from 'moment'
export class EventCalendar {
  private _created: Date;
  private _creator: string;
  private _descriptionEvent: string;
  private _eventName: string;
  private _fromDate: Date;
  private _toDate: Date;
  private _modified: Date;
  private _modifier: string;
  private _nbParticipants: number;
  private _office: string;
  private _organiser: string;
  private _organiserFullname: string;
  private _idSalle: number;
  private _salleColor: string;
  private _salleName: string;
  private _whatEvent: string;
  private _whatEventFullname: string;
  private _id: string;
  private _isAllDay: boolean;

  constructor(data: any) {
    this.created = new Date(data.created.replace('Z', ''));
    this.creator = data.creator;
    this.descriptionEvent = data.descriptionEvent;
    this.eventName = data.eventname;
    this.fromDate = new Date(data.fromDate.replace('Z', ''));
    this.toDate = new Date(data.toDate.replace('Z', ''));
    this.modified = new Date(data.modified.replace('Z', ''));
    this.modifier = data.modifier;
    this.nbParticipants = data.nbParticipants;
    this.office = data.office;
    this.organiser = data.organiser;
    this.organiserFullname = data.organiserFullname;
    this.idSalle = data.salle;
    this.whatEvent = data.whatEvent;
    this.whatEventFullname = data.whatEventFullname;
    this.salleColor = data.salleColor;
    this.salleName = data.salleName;
    this.id = data.id;

    // Toute la journée ?
    this.isAllDay =
      moment(this.fromDate).hour() === 8 && moment(this.toDate).hour() === 20;
  }

  get created(): Date {
    return this._created;
  }

  set created(value: Date) {
    this._created = value;
  }

  get creator(): string {
    return this._creator;
  }

  set creator(value: string) {
    this._creator = value;
  }

  get descriptionEvent(): string {
    return this._descriptionEvent;
  }

  set descriptionEvent(value: string) {
    this._descriptionEvent = value;
  }

  get eventName(): string {
    return this._eventName;
  }

  set eventName(value: string) {
    this._eventName = value;
  }

  get fromDate(): Date {
    return this._fromDate;
  }

  set fromDate(value: Date) {
    this._fromDate = value;
  }

  get toDate(): Date {
    return this._toDate;
  }

  set toDate(value: Date) {
    this._toDate = value;
  }

  get modified(): Date {
    return this._modified;
  }

  set modified(value: Date) {
    this._modified = value;
  }

  get modifier(): string {
    return this._modifier;
  }

  set modifier(value: string) {
    this._modifier = value;
  }

  get nbParticipants(): number {
    return this._nbParticipants;
  }

  set nbParticipants(value: number) {
    this._nbParticipants = value;
  }

  get office(): string {
    return this._office;
  }

  set office(value: string) {
    this._office = value;
  }

  get organiser(): string {
    return this._organiser;
  }

  set organiser(value: string) {
    this._organiser = value;
  }

  get organiserFullname(): string {
    return this._organiserFullname;
  }

  set organiserFullname(value: string) {
    this._organiserFullname = value;
  }

  get idSalle(): number {
    return this._idSalle;
  }

  set idSalle(value: number) {
    this._idSalle = value;
  }

  get whatEvent(): string {
    return this._whatEvent;
  }

  set whatEvent(value: string) {
    this._whatEvent = value;
  }

  get salleColor(): string {
    return this._salleColor;
  }

  set salleColor(value: string) {
    this._salleColor = value;
  }

  get salleName(): string {
    return this._salleName;
  }

  set salleName(value: string) {
    this._salleName = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get whatEventFullname(): string {
    return this._whatEventFullname;
  }

  set whatEventFullname(value: string) {
    this._whatEventFullname = value;
  }

  get isAllDay(): boolean {
    return this._isAllDay;
  }

  set isAllDay(value: boolean) {
    this._isAllDay = value;
  }
}
